<template>
  <VMenu
    :distance="10"
    :skidding="135"
    placement="right-end"
  >
    <div
      class="px-4 py-3 bg-primary text-white select-none flex flex-row justify-between items-center transition cursor-pointer group"
    >
      <span
        v-if="!compactMode"
        id="active-company-name"
        class="font-medium"
      >
        {{ activeCompany.name }}
      </span>
      <AppIcon
        icon="cog"
        class="group-hover:rotate-180 transition"
        :class="{ 'm-auto': compactMode }"
      />
    </div>
    <template #popper>
      <SettingsMenuContent v-bind="{ companies }" />
    </template>
  </VMenu>
</template>

<script setup lang="ts">
import { Company, getUserCompanies } from "@q-food/q-food";
import { Menu as VMenu } from "floating-vue";
import { useAppSidebarStore } from "~stores/AppSidebar";
import { useUserStore } from "~stores/User";

const companies = ref<Company[]>([]);
const { compactMode } = storeToRefs(useAppSidebarStore());
const { activeCompany } = storeToRefs(useUserStore());

onMounted(async () => {
	companies.value = await getUserCompanies();
});
</script>

<style scoped></style>
